
import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins
export default {
    extends: Pie,
    mixins: [reactiveProp],
    props: ['data'],
    mounted() {
        this.renderChart(
          this.chartData,
            {
              hoverBorderWidth: 150,
              legend: {
                  display: false
                  }
            }
        )
    }
};